import { Injectable } from '@angular/core';
declare var RazorpayCheckout: any;

@Injectable({
  providedIn: 'root'
})
export class RazorpayService {
  paymentAmount: number = 333;
  currency: string = 'INR';
  currencyIcon: string = '₹';
  razor_key = 'rzp_test_z5BtLHwTy4iYds';
  cardDetails: any = {};

  constructor() { }

  payWithRazor() {
    var options = {
      description: 'Credits towards consultation',
      image: 'https://i.imgur.com/3g7nmJC.png',
      currency: this.currency, // your 3 letter currency code
      key: 'rzp_test_1DP5mmOlF5G5ag', // your Key Id from Razorpay dashboard
      amount: this.paymentAmount, // Payment amount in smallest denomiation e.g. cents for USD
      name: 'foo',
      prefill: {
        email: 'yuviyuvan95@gmail.com',
        contact: '9790726699',
        name: 'Onslr'
      },
      theme: {
        color: '#F37254'
      },
      modal: {
        ondismiss: function () {
          alert('dismissed')
        }
      }
    };

    var successCallback = function (payment_id) {
      alert('payment_id: ' + payment_id);
    };

    var cancelCallback = function (error) {
      alert(error.description + ' (Error ' + error.code + ')');
    };

    RazorpayCheckout.open(options, successCallback, cancelCallback);
  }
  
}
